import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MainLayoutRoutingModule } from "./main-layout-routing.module";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { ReUsableModule } from "../../Components/re-usable.module";

@NgModule({
  declarations: [MainLayoutComponent],
  imports: [CommonModule, MainLayoutRoutingModule, ReUsableModule],
})
export class MainLayoutModule {}
